import React, { Fragment, useState } from 'react';
import { Container, Grid, Table, Card, Page, Form, Dimmer } from "tabler-react";
import { useFetch } from '../../lib/useFetch';
import PaginationBar from '../../components/pagination';
import { formatDate } from '../../lib/helpers';
import { useParams } from 'react-router-dom';

const shipmentHeaders = ["Trip Type", "From City", "To City", "Capacity", "Vehicle Type", "Rewards", "Status", "Created At", "Trip Date"];

const UserTrips = () => {
  const [page, setPage] = useState(1);
  const { id } = useParams()
  const { data, loading, totalCount } = useFetch(`trips?userId=${id}&page=${page}`);

  return (
    <Fragment>
      <Container>
        <Page.Header>
          <Page.Title>User Trips</Page.Title>
        </Page.Header>
        <Grid>
          <Grid.Row>
            <Card>
              <Dimmer active={loading} loader={loading}>
                <Card.Header>
                  <Card.Options>
                    <Form.Input
                      icon="search"
                      placeholder="Search for..."
                      position="append"
                    />
                  </Card.Options>
                </Card.Header>
                {!loading && data.length < 1 ?
                  <div className="alert alert-primary m-0">
                    No Trips to show!
                  </div> :
                  <>
                    <Table
                      hasOutline
                      striped
                    >
                      <Table.Header>
                        {shipmentHeaders.map((head, i) => (
                          <Table.ColHeader
                            key={`tableHeader-${i}`}
                          >
                            {head}
                          </Table.ColHeader>
                        ))}
                      </Table.Header>
                      <Table.Body>
                        {data && data.map(({ tripType, fromCity, toCity, tripCapacity, vehicleType, totalRewards, state, createdAt, tripDate }, i) => (
                          <Table.Row key={i}>
                            <Table.Col>
                              {tripType}
                            </Table.Col>

                            <Table.Col>
                              {fromCity.name}
                            </Table.Col>

                            <Table.Col>
                              {toCity.name}
                            </Table.Col>

                            <Table.Col>
                              {tripCapacity}
                            </Table.Col>

                            <Table.Col>
                              {vehicleType}
                            </Table.Col>

                            <Table.Col>
                              {totalRewards}
                            </Table.Col>

                            <Table.Col>
                              {state}
                            </Table.Col>

                            <Table.Col>
                              {formatDate(new Date(createdAt))}
                            </Table.Col>

                            <Table.Col>
                              {formatDate(new Date(tripDate))}
                            </Table.Col>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>

                    <PaginationBar
                      page={page}
                      totalCount={totalCount}
                      setPage={setPage}
                    /></>
                }
              </Dimmer>
            </Card>
          </Grid.Row>
        </Grid>
      </Container>
    </Fragment>
  );
}
export default UserTrips;